import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import ComboBox from 'Components/ComboBox'
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { UTILISATION } from 'utils/constants'
import { TYPE_DE_BIEN } from 'utils/constants'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { Input } from '../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import { currentDate } from '../../../utils/helpers'
import urls from '../../../utils/urls'
import ImmobilierFormDialog from './ImmobilierFormDialog'
import ListDocuments from './ListDocuments'
import { useDispatch } from 'react-redux'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import CreateMessage from 'containers/MyInbox/CreateMessage'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export const MonImmobilier = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [mOpen, setMOpen] = useState(false)
  let w_logement = localStorage.getItem('w-logement')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const dispatch = useDispatch()
  const [documents, setDocuments] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const formRef = useRef()
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()

  const [energyClassification, setEnergyClassification] = useState([])
  const [typeDeBien, setTypeDeBien] = useState([])
  const [typeDeChauffage, setTypeDeChauffage] = useState([])
  const [Norme, setNorme] = useState([])
  const [typeChauffeEau, setTypeChauffeEau] = useState([])
  const [nombreHabitant, setNombreHabitant] = useState([])
  const [superficies, setSuperficie] = useState([])
  const [getPays, setPays] = useState([])
  const [contacts, setContacts] = useState([])
  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      pays: '',
      utilisation: '',
      nom: '',
      created_at: currentDate(),
      pieces: '',
      superficie: '',
      consumption: '',
      energy_classification: '',
      type_de_bien: '',
    },
  })

  useEffect(() => {
    fetchDocuments()
  }, [location.search])

  useEffect(() => {
    fetchImmoFootPrint1()
    fetchPays()
    fetchAllContacts()
    if (w_logement) {
      formRef.current.handleClickOpen(false)
    }
  }, [])

  const handleUpdateList = (document, activeDocument) => {
    let tmpObject = JSON.parse(JSON.stringify(documents))
    if (activeDocument.utilisation) {
      const activeObjIndex = tmpObject.results.findIndex((v) => v.id === activeDocument.id)
      tmpObject.results[activeObjIndex] = document
      setDocuments({ ...tmpObject })
    } else {
      tmpObject.results.push({ ...document })
      setDocuments({ ...tmpObject, count: tmpObject.count + 1 })
    }
  }
  const fetchDocuments = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudImmobilier}?${location.search.slice(1)}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setDocuments({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const filterDocuments = (data) => {
    // const payload = {
    //   ...data,
    // }
    // if (data.type_de_bien) {
    //   payload.type_de_bien = data.type_de_bien.id
    // }
    // if (data.type_de_bien === null) {
    //   delete payload.type_de_bien
    // }
    // if (data.utilisation) {
    //   payload.utilisation = data.utilisation.value
    // }
    // if (data.utilisation === null) {
    //   delete payload.utilisation
    // }
    let s = {
      ...data,
      pays: data.pays ? data.pays.id : '',
      superficie: data.superficie ? data.superficie.id : '',
      energy_classification: data.energy_classification ? data.energy_classification.id : '',
      consumption: data.consumption ? data.consumption.id : '',
      type_de_bien: data.type_de_bien ? data.type_de_bien.id : '',
      utilisation: data.utilisation ? data.utilisation.value : '',
    }
    const queryParams = new URLSearchParams(s).toString()
    navigate(`?${queryParams}`)
  }

  const deleteBulkDocuments = async () => {
    if (selectedRows.length === 0) {
      // LAP-733 (GE022)
      alert(t('realEstate.alertSelectDoc'))
    } else {
      const filteredDocuments = documents.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setDocuments({
        ...documents,
        results: filteredDocuments,
        count: documents.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.bulkImmobilierFlag,
        { selected: selectedRows },
        {},
        true,
      )
    }
  }

  const fetchAllContacts = async () => {
    const url = urls.getAllContacts
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterContacts = []
      data.forEach((v) => {
        filterContacts.push({ label: `${v.Nom}`, id: v.id })
      })
      setContacts([...filterContacts])
    }
  }
  const fetchPays = async () => {
    const url = '/api/Social/get-countries/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPays = []
      data.forEach((v) => {
        filterPays.push({ label: `${v.CountryCode}/${v.Designation}`, id: v.id })
      })
      setPays([...filterPays])
    }
  }
  const fetchImmoFootPrint1 = async () => {
    const url = '/api/domicile/get-immofootprint1/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const energy_classification = []
      const type_de_bien = []
      const type_de_chauffage = []
      const norme = []
      const type_chauffe_eau = []
      const nombre_habitant = []
      const superficiess = []
      data.forEach((v) => {
        if (v.consumption_post === 'Classe énérgétique')
          energy_classification.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Type de bien')
          type_de_bien.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Type de chauffage')
          type_de_chauffage.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Norme') norme.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Type de chauffe eau')
          type_chauffe_eau.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === "Nombre d'habitant")
          nombre_habitant.push({ label: `${v.answer}`, id: v.id })
        if (v.consumption_post === 'Superficie')
          superficiess.push({ label: `${v.answer}`, id: v.id })
      })
      setEnergyClassification([...energy_classification])
      setTypeDeBien([...type_de_bien])
      setTypeDeChauffage([...type_de_chauffage])
      setNorme([...norme])
      setTypeChauffeEau([...type_chauffe_eau])
      setNombreHabitant([...nombre_habitant])
      setSuperficie([...superficiess])
    }
  }

  const clearFilter = () => {
    // setGeneral(true)
    navigate(``)

    let v = document.getElementsByClassName('MuiAutocomplete-clearIndicator')
    if (v.length > 0) {
      v[0].click()
      v[1].click()
      v[2].click()
      v[3].click()
      v[4].click()
    }
    reset()
  }
  return (
    <>
      {mOpen && (
        <CreateMessage
          setMOpen={setMOpen}
          /* LAP-733 (GE022) */
          title={t('realEstate.shareTitle')}
          settingId={3}
          immobilier={documents.results.filter((v) => v.id === selectedRows[0])[0]}
        />
      )}
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          {isMobile ? (
            <Box color={'white'} display={'flex'} gap={2}>
              <AddCircleIcon onClick={() => formRef.current.handleClickOpen(false)} />

              <RemoveCircleIcon onClick={deleteBulkDocuments} />
              <EditIcon
                onClick={() => {
                  if (selectedRows.length === 1) {
                    formRef.current.handleClickOpen(true)
                  } else {
                    /* LAP-733 (GE022) */
                    alert(t('realEstate.alertSelectDocEdit'))
                  }
                }}
              />
            </Box>
          ) : (
            <Box>
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setMOpen(true)
                  } else {
                    /* LAP-733 (GE022) */
                    alert(t('realEstate.alertSelectDocShare'))
                  }
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('realEstate.btnShare')}
              </CustomButton>
              <CustomButton onClick={() => formRef.current.handleClickOpen(false)}>
                {/* LAP-733 (GE022) */}
                {t('realEstate.btnCreate')}
              </CustomButton>
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    formRef.current.handleClickOpen(true)
                  } else {
                    /* LAP-733 (GE022) */
                    alert(t('realEstate.alertSelectDocEdit'))
                  }
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('realEstate.btnEdit')}
              </CustomButton>
              {/* LAP-733 (GE022) */}
              <CustomButton onClick={deleteBulkDocuments}>{t('realEstate.btnDelete')}</CustomButton>
            </Box>
          )}
        </Box>
        <ListDocuments
          fetchDocuments={fetchDocuments}
          setSelectedRows={setSelectedRows}
          documents={documents}
        />
        <ImmobilierFormDialog
          ref={formRef}
          documents={documents}
          setDocuments={setDocuments}
          handleUpdateList={handleUpdateList}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          energyClassification={energyClassification}
          typeDeBien={typeDeBien}
          typeDeChauffage={typeDeChauffage}
          Norme={Norme}
          typeChauffeEau={typeChauffeEau}
          nombreHabitant={nombreHabitant}
          superficies={superficies}
          getPays={getPays}
          contacts={contacts}
        />
      </Container>
    </>
  )
}
